<div class="snackbar-container" [class.show]="isShown">
  {{ message }}
</div>
